import { Table } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import ReportTeamsBody from './ReportTeamsBody';
import type { ReportTeamTableProps } from '../types';

const ReportTeamTable = ({ teamList }: ReportTeamTableProps) => {
    const { t } = useTranslation(['Reports']);

    return (
        <div className="crm-table-wrap">
            <Table className="ObjectRepTable table-hover">
                <thead>
                    <tr className="bg-light">
                        <td className="head-name">{t('teamsFields.name')}</td>
                        <td className="text-end head-income">{t('teamsFields.income')}</td>
                    </tr>
                </thead>
                <ReportTeamsBody teamList={teamList} />
            </Table>
        </div>
    );
};

export default ReportTeamTable;
